export default "__VITE_ASSET__u$Exe4GR__"